module.exports = __webpack_public_path__ + "img/history.3d4e6f1c.svg";